import { useEffect, type ReactNode } from 'react';
import { Navigate, useRouterState } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/authStore';
import { FullPageSpinner } from './FullPageMessage';
import { OnboardingGate } from './OnboardingGate';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, isAuthenticated, isInitializing, checkAuth } = useAuthStore();
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const search = useRouterState({ select: (state) => state.location.searchStr });
  const returnTo = `${pathname}${search}`;

  useEffect(() => {
    if (isInitializing) void checkAuth();
  }, [checkAuth, isInitializing]);

  if (isInitializing) return <FullPageSpinner />;
  if (!isAuthenticated || !user) {
    if (pathname === '/login') return null;
    return <Navigate to="/login" search={{ returnTo }} />;
  }
  if (user.needsOnboarding || user.needsOrgNoticeConsent) return <OnboardingGate />;
  return <>{children}</>;
}
